export const game: GameSetup = {
    history: {
        expiration: 1000 * 60 * 60 * 24,
    },
    info: {
        budget: '<b>BUDGET</b> is the amount of money you have left to spend.',
        currentPot: '<b>CURRENT POT</b> is the value of all the community cards you can currently see.',
        earnings:
            "<b>EARNINGS</b> are the money you've won from playing.<br/><br/>Even if you spend the money to continue playing, this will be the cumulative total of what you've earned.",
        expectedPot:
            '<b>EXPECTED POT</b> is the value of all the community cards assuming an average value of cards you can not see.',
        reset: '<b>RESET</b> will erase your earnings and start your budget over at ${startingBudget}.',
        rewind: '<b>REWIND</b> will take you back one step in time and the cards will be reshuffled so it will not be the exact same.<br/><br/>This allow you to practice decision making in similar situations and see how there can be different outcomes to the same decision.',
        winPercentage:
            '<b>WIN %</b> is the percentage likelihood you have of winning the hand assuming you and your opponents all stay in.',
    },
    practiceLimit: 10,
    promo: {
        buttonLabel: 'Try Krobar.ai free',
        image: '/assets/game/krobar-black.svg',
        imageAlt: 'Krobar logo',
        link: 'https://krobar.ai',
        text: 'Krobar helps you compare options, model risk, and explain the business case behind your next move.',
        title: 'Turn the next hand into a stakeholder-ready decision.',
    },
    reportLink: 'mailto:innovate@kromatic.com?subject=Startup Poker Feedback&body=URL: {url}\nFeedback: ',
    results: {
        draw: {
            icon: '/assets/results/draw.png',
            message: "it's a draw",
            title: 'Draw',
        },
        fold: {
            icon: '/assets/results/fold.png',
            message: '',
            title: 'You Fold',
        },
        lose: {
            icon: '/assets/results/lose.png',
            message: 'your opponent wins with {opponentHandName}',
            title: 'You Lose',
        },
        win: {
            icon: '/assets/results/win.png',
            message: 'you win with {holeHandName}',
            title: 'You Win',
        },
    },
};
